import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Order, OrderDetail} from '../models';
import {objectToParams} from '../helpers/util';
import {ApiService} from './api.service';
import {Constants} from '../configs';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private apiService: ApiService) {
  }

  read(data: any): Observable<Order[]> {
    return this.apiService.get(
      this.apiService.orders + '?' + objectToParams(data)
    );
  }

  readDetail(orderId: number): Observable<OrderDetail[]> {
    return this.apiService.get(this.apiService.orders + '/' + orderId);
  }

  /** Metodo que imprime guía de entrega */
  updateWithDraw(orderId: number, body: object, printType: String): Observable<any> {
    return this.apiService.putHTML(
      `${this.apiService.orders}/${orderId}/withdraw/${printType}`,
      body
    ).pipe(
      map(response => {
        const exist = response.toLowerCase().includes((Constants.Order.MESSAGE_STATE_PAY.PAID).toLowerCase());
        return exist ? false : response;
      }));
  }

  returnProcess(orderId: number, body: object): Observable<any> {
    return this.apiService.putHTML(
      `${this.apiService.orders}/${orderId}/return`,
      body
    ).pipe(
      map(response => {
        const exist = response.toLowerCase().includes((Constants.Order.MESSAGE_STATE_PAY.PAID).toLowerCase());
        return exist ? false : response;
      }));
  }

  getListOfDeliver(orderId): Observable<any> {
    return this.apiService.get(
      `${this.apiService.orders}/withdraw/${orderId}`
    ).pipe();
  }

  printWithdrawDeliver(orderId: number): Observable<any> {
    return this.apiService.getHTML(
      `${this.apiService.orders}/${orderId}/invoice`
    ).pipe();
  }

  printWithdrawDeliverThermal(orderId: number): Observable<any> {
    return this.apiService.getHTML(
      `${this.apiService.orders}/${orderId}/invoice/thermal`
    ).pipe();
  }

  updateLocate(orderId: number, body: object): Observable<OrderDetail[]> {
    return this.apiService.put(
      `${this.apiService.orders}/${orderId}/locate`,
      body
    );
  }

  locateDispatches(body: object): Observable<OrderDetail[]> {
    return this.apiService.put(
      `${this.apiService.orders}/locate`,
      body
    );
  }

  getReturnedReason(): Observable<any> {
    return this.apiService.get(`${this.apiService.configuration}`.replace('{{groupCode}}', 'RETURN_REASON_CONFIG'));
  }

}
